import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataQaDirective, DataQaInputDirective } from '@directives';

@NgModule({
  declarations: [DataQaInputDirective, DataQaDirective],
  imports: [CommonModule],
  exports: [DataQaInputDirective, DataQaDirective],
})
export class DirectiveModule {}
